export const constants = {
  colors: {
    allergiesColor: `#F7D1F4`,
    medicineColor: `#D9E2FC`,
    diagnoseColor: `#FCF0CE`,
    vaccineColor: `#D1FDBD`,
    documentColor: `#BBB6FA`,
    primary: "#47B6F6",
  },
};
export const CATEGORIES_TYPES = {
  allergies: `allergies`,
  medicines: `medicines`,
  diagnoses: `diagnoses`,
  vaccines: `vaccines`,
  documents: `documents`,
};
